import React, { useState } from 'react';
import { View } from 'react-native';
import { FormattedMessage } from 'react-intl';
import { Button } from '@hmsexp/component-library';
import { connect } from 'react-redux';
import styles from './styles';

const FetchHotelErrorHandler = ({ selectedHotel, fetchHotels }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onError = () => {
    setIsLoading(false);
  };

  const onRetryButtonClick = () => {
    setIsLoading(true);
    if (!selectedHotel) {
      fetchHotels(onError);
      return;
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.subContainer}>
        <svg width="338" height="155" viewBox="0 0 338 155">
          <use xlinkHref="#internal-error" />
        </svg>
        <FormattedMessage id="collectPaymentErrorMessage" />
        <View style={styles.button}>
          <Button loading={isLoading} onClick={onRetryButtonClick} title="Retry" />
        </View>
      </View>
    </View>
  );
};

const mapStateToProps = state => ({
  selectedHotel: state.app.active_hotel
});

export default connect(mapStateToProps, null)(FetchHotelErrorHandler);
